import React, { Component } from 'react';
import {
  CCard,
  CCardBody,
  CCardHeader,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { withRouter } from 'react-router-dom'
import { APIS } from '../../config'

class Rich extends Component {

  state = {
    topHolders: []
  }

  async componentDidMount() {
    try {
      let res = await fetch(APIS + 'metamui/top_holders');
      let topHolders = await res.json();
      console.log(topHolders)
      this.setState({ topHolders: topHolders.data })
    } catch (e) {
      console.log(e);
    }
  }

  formatNumber(num) {
    // Try to convert the input to a number
    const parsedNum = typeof num === 'number' ? num : parseFloat(num);

    // If the conversion fails or the value is still NaN, return the original input
    if (isNaN(parsedNum)) return num;

    // Format the number with commas and up to 6 decimals
    return parsedNum.toLocaleString(undefined, {
      minimumFractionDigits: 6,
      maximumFractionDigits: 6,
    });
  }


  render() {

    return (
      <div>
        <CCard>
          <CCardHeader>
            <strong>Top MetaMUI Holders</strong>
          </CCardHeader>
          <CCardBody>
            <div className="table-wrapper-scroll-y my-custom-scrollbar" style={{ maxHeight: '600px' }}>
              <table className="table table-hover table-outline mb-0 table-responsive d-sm-table " >
                <thead className="thead-light">
                  <tr>
                    <th className="text-center"><CIcon name="cil-people" /></th>
                    <th>Account Id</th>
                    <th>Balance</th>
                    <th>Percentage</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.topHolders.map((e, index) => (
                    <tr key={index}>
                      <td className="text-center">
                        <div className="c-avatar">
                          <strong> {index + 1} </strong>
                        </div>
                      </td>
                      <td>
                        <div className="small text-muted"></div>
                        <strong>{e.did}</strong>
                      </td>
                      <td>
                        <strong>{this.formatNumber(e.balance_total)} MetaMUI</strong>
                      </td>
                      <td>
                        <strong>{e.percentage} %</strong>
                      </td>
                    </tr>
                  ))}
                </tbody>

              </table>
            </div>
          </CCardBody>
        </CCard>
      </div>
    );
  }
}

export default withRouter(Rich);